import React, { createContext, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

export const BlogContext = createContext(null)

export const BlogProvider = ({ children }) => {
	const {
		allSanityBlogPost,
		allSanityBlogCategory,
		allSanityBlogAuthor,
	} = useStaticQuery(query)

	const [$category, set$category] = useState(null)
	const [$pagination, set$pagination] = useState(0)

	const value = {
		categories: allSanityBlogCategory.nodes,
		posts: allSanityBlogPost.nodes,
		authors: allSanityBlogAuthor.nodes,
		$category, set$category,
		$pagination, set$pagination,
	}

	return <BlogContext.Provider value={value} children={children} />
}

export const query = graphql`query BlogContext {
	# for blog listing
	allSanityBlogPost(sort: {fields: publishDate, order: DESC}) {
		nodes {
			_id
			title
			_rawContent
			excerpt
			featuredImage { asset { gatsbyImageData(placeholder: NONE, aspectRatio: 1.5, width: 600) } }
			author {
				name
			}
			categories {
				name
			}
			publishDate
			metaInfo { ...metaInfo }
		}
	}
	allSanityBlogCategory(sort: {fields: orderRank, order: ASC}) {
		nodes {
			name
		}
	}
	allSanityBlogAuthor {
		nodes {
			name
		}
	}
}`
